import FilterConstants from '../filter-constants';

////////////////////////////////////////////////////////////////////////////////////
// validation - functions for character and field validation  vvvvvvvvvvvvvvvv    //
////////////////////////////////////////////////////////////////////////////////////

// Function for Character Validation
// Inputs: value - value to be validated
//         type - value field type
//         scope - used for custom validation, usually contains a Regular Expression, otherwise null
// Returns: result - true when valid
export function validateCharacterInput(value: string, type: string, scope?: RegExp): boolean {
  return validateFieldInput(value, type, scope);
}

// Function for Field Validation
// Inputs: value - value to be validated
//         type - value field type
//         scope - used for custom validation, usually contains a Regular Expression, otherwise null
// Returns: result - true when valid
export function validateFieldInput(value: string, type: string, scope?: RegExp): boolean {
  let result = true;
  let pattern = /^/;
  switch (type) {
    case FilterConstants.fieldTypes.AlphaNumeric:
      pattern = /^[0-9a-zA-Z]+$/;
      result = pattern.test(value.toString());
      break;
    case FilterConstants.fieldTypes.Alphabet:
      pattern = /^[a-zA-Z]+$/;
      result = pattern.test(value.toString());
      break;
    case FilterConstants.fieldTypes.Numeric:
      pattern = /^[0-9-]+$/;
      result = pattern.test(value.toString());
      if (result) {
        result = !isNaN(Number(value));
      }
      break;
    case FilterConstants.fieldTypes.NumericDecimal:
      pattern = /^[+-]?\d+(\.\d+)?$/;
      result = pattern.test(value.toString());
      if (result) {
        result = !isNaN(Number(value));
      }
      break;
    case FilterConstants.fieldTypes.Engineering: {
      const suffixes = ['a', 'f', 'p', 'n', 'u', 'µ', 'm', 'k', 'M', 'G', 'T', 'P'];
      const input = value.toString();
      if (input.length > 1) {
        let isSuffixFound = false;
        const suffix = input.substring(input.length - 1, input.length);
        for (let i = 0; i < suffixes.length; i++) {
          if (suffixes[i] === suffix) {
            isSuffixFound = true;
          }
        }
        if (!isSuffixFound) {
          if (isNaN(Number(suffix))) {
            result = false;
          } else {
            if (isNaN(Number(input))) {
              result = false;
            }
          }
        }
        if (isSuffixFound) {
          if (isNaN(Number(input.substring(0, input.length - 1)))) {
            result = false;
          }
        }
      } else {
        if (isNaN(Number(input))) {
          result = false;
        }
      }
      if (value.replace(/\s/g, '') === '') {
        result = false;
      }
      break;
    }
    case FilterConstants.fieldTypes.Custom:
      if (scope) {
        pattern = scope;
        result = pattern.test(value.toString());
      }
      break;
    case FilterConstants.fieldTypes.AllChars:
    default:
      break;
  }

  return result;
}
